<template>
  <TopProgressBar />
  <MainHeader v-if="showLayout" />
  <MainSidebar v-if="showLayout" />
  <Toast />
  <div :class="[
      ' d-flex flex-column transition overflow-hidden full-page',
      { 'main-content': showLayout } 
    ]">
    <router-view />
    <MainFooter v-if="showLayout" />
  </div>
</template>

<script lang="ts">
import { defineComponent, watchEffect, computed, watch } from "vue";
import { useRoute } from "vue-router";
import stateStore from "./utils/store";
import { useSettingsStore } from "./stores/settings";

import MainHeader from "./components/Layouts/MainHeader.vue";
import MainSidebar from "./components/Layouts/MainSidebar.vue";
import MainFooter from "./components/Layouts/MainFooter.vue";
import TopProgressBar from "./components/Common/TopProgressBar.vue";

export default defineComponent({
  name: "App",
  components: {
    MainHeader,
    MainSidebar,
    MainFooter,
    TopProgressBar,
  },
  mounted() {
    document.body.classList.add("bg-body-secondary");
  },
  setup() {
    const stateStoreInstance = stateStore;
    const settingsStore = useSettingsStore();

    // Watch sidebar state
    watchEffect(() => {
      if (stateStoreInstance.open) {
        document.body.classList.remove("sidebar-show");
        document.body.classList.add("sidebar-hide");
        console.log("show");
      } else {
        document.body.classList.remove("sidebar-hide");
        document.body.classList.add("sidebar-show");
        console.log("hide");
      }
    });

    // Determine if layout should show
    const route = useRoute();
    const showLayout = computed(() => {
      return !["/login", "/register", "/hashUser"].includes(route.path);
    });

    // Fetch settings once when the authenticated layout is first shown
    watch(showLayout, (val) => {
      if (val) settingsStore.fetchSettings();
    }, { immediate: true });

    // Update page title whenever settings.name is loaded
    watch(() => settingsStore.name, (name) => {
      if (name) document.title = name;
    });

    return { showLayout };
  },
});
</script>
